<template>
  <v-select
    class="select"
    v-model="fields.value"
    :label="label"
    :options="items"
    :reduce="reduceFunction"
    :placeholder="placeholder"
    :loading="loading"
    :disabled="disabled"
    :multiple="multiple"
    @input="$emit('input')"
  >
    <div slot="no-options" v-html="noOptions"></div>
    <template v-slot:option="data">
      <slot name="option" :data="data"></slot>
    </template>
    <template #selected-option="data">
      <slot name="selected-option" :data="data"></slot>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectItems',
  emits: ['input'],
  model: {
    prop: 'value',
    event: 'update:value',
  },
  watch: {
    'fields.value': function () {
      this.$emit('update:value', this.fields.value);
    },
    value() {
      this.fields.value = this.value;
    },
  },
  props: {
    value: {
      required: false,
    },
    label: {
      type: String,
      default: 'Sem label',
      required: true,
    },
    /** Todos os items a serem exibidos no select */
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    reduceFunction: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    noOptions: {
      type: String,
      default: 'Sem itens encontrados.',
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  created() {
    this.fields.value = this.value;
  },
  data() {
    return {
      fields: {
        value: null,
      },
    };
  },
};
</script>